"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONBOARDING_NO_PERMISSION_COPY = void 0;
exports.ONBOARDING_NO_PERMISSION_COPY = {
    CHECK_PERMISSION: 'Check Salesforce User Permissions',
    PARTIAL_CONTACT_US: 'If you continue to experience issues, please contact us at ',
    PARTIAL_INFORMATION: ' Information on the necessary permissions can be found ',
    PARTIAL_HERE: 'here',
    PARTIAL_PERIOD: '.',
    PARTIAL_ZENDESK_LINK: 'https://sonarsoftware.zendesk.com/hc/en-us/articles/4409726131597-Managing-the-Sync-with-Salesforce#h_01FGC4KDE15F2KPQYNVTNG5CXH%7D',
    AROVY_UNABLE_TO_CONNECT: 'Arovy was unable to connect to this Salesforce org. The authenticated user has insufficient Salesforce permissions to successfully sync this Salesforce organization. ' +
        ' Please update your permissions and try again.',
};
//# sourceMappingURL=ONBOARDING_NO_PERMISSION_COPY.js.map